import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bf664d7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "AiConfigurator" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "AiConfigurator__bg" }, null, -1))
const _hoisted_3 = { class: "AiConfigurator__panel" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "AiConfigurator__header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "AiConfigurator__eyebrow" }, "Verenza AI Configurator"),
  /*#__PURE__*/_createElementVNode("h2", { class: "AiConfigurator__title font-soligant" }, "Znajdź bieliznę dopasowaną do Twojego nastroju"),
  /*#__PURE__*/_createElementVNode("p", { class: "AiConfigurator__subtitle" }, " Odpowiedz na kilka pytań. Algorytm policzy dopasowanie i pokaże najlepsze propozycje. ")
], -1))
const _hoisted_5 = {
  key: 0,
  class: "AiConfigurator__state"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "AiConfigurator__spinner" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Ładuję konfigurator...", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "AiConfigurator__progressWrap" }
const _hoisted_10 = { class: "AiConfigurator__progressTrack" }
const _hoisted_11 = { class: "AiConfigurator__progressLabel" }
const _hoisted_12 = { class: "AiConfigurator__question font-soligant" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "AiConfigurator__actions" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 2,
  class: "AiConfigurator__results"
}
const _hoisted_19 = { class: "AiConfigurator__resultsHead" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "AiConfigurator__question font-soligant" }, "Najlepsze dopasowania dla Ciebie", -1))
const _hoisted_21 = { class: "AiConfigurator__subtitleSmall" }
const _hoisted_22 = { class: "AiConfigurator__resultsControls" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "match_desc" }, "Najlepsze dopasowanie", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "price_asc" }, "Cena rosnąco", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "price_desc" }, "Cena malejąco", -1))
const _hoisted_26 = [
  _hoisted_23,
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = { class: "AiConfigurator__actions AiConfigurator__actions--results" }
const _hoisted_28 = {
  key: 0,
  class: "AiConfigurator__info"
}
const _hoisted_29 = {
  key: 1,
  class: "AiConfigurator__error"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "AiConfigurator__feedbackHint" }, [
  /*#__PURE__*/_createTextVNode(" Doprecyzuj wyniki: "),
  /*#__PURE__*/_createElementVNode("strong", null, "♥ Trafione"),
  /*#__PURE__*/_createTextVNode(" wzmacnia podobne propozycje, a "),
  /*#__PURE__*/_createElementVNode("strong", null, "✕ Nie dla mnie"),
  /*#__PURE__*/_createTextVNode(" je osłabia. ")
], -1))
const _hoisted_31 = {
  key: 2,
  class: "AiConfigurator__state"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "AiConfigurator__spinner" }, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Przeliczam ranking produktów...", -1))
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = {
  key: 3,
  class: "AiConfigurator__state"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Brak wyników dla wskazanych kryteriów. Zmień odpowiedzi i spróbuj ponownie.", -1))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = {
  key: 4,
  class: "AiConfigurator__grid"
}
const _hoisted_39 = {
  key: 0,
  class: "AiConfigurator__updating"
}
const _hoisted_40 = ["href"]
const _hoisted_41 = ["src", "alt"]
const _hoisted_42 = { class: "AiConfigurator__score" }
const _hoisted_43 = { class: "AiConfigurator__cardBody" }
const _hoisted_44 = ["href"]
const _hoisted_45 = { class: "AiConfigurator__price" }
const _hoisted_46 = { class: "AiConfigurator__why" }
const _hoisted_47 = { class: "AiConfigurator__tags" }
const _hoisted_48 = { class: "AiConfigurator__cardActions" }
const _hoisted_49 = ["href"]
const _hoisted_50 = ["disabled", "onClick"]
const _hoisted_51 = { class: "AiConfigurator__feedback" }
const _hoisted_52 = ["disabled", "onClick"]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "♥", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Trafione", -1))
const _hoisted_55 = [
  _hoisted_53,
  _hoisted_54
]
const _hoisted_56 = ["disabled", "onClick"]
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "✕", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Nie dla mnie", -1))
const _hoisted_59 = [
  _hoisted_57,
  _hoisted_58
]
const _hoisted_60 = {
  key: 3,
  class: "AiConfigurator__error"
}

import { computed, onMounted } from 'vue';
import { useAiConfigurator } from './useAiConfigurator';


export default {
  __name: 'AiConfigurator',
  setup(__props) {

const {
    canGoBack,
    canGoForward,
    currentStep,
    editAnswers,
    errorMessage,
    formatPrice,
    getFeedbackType,
    goToNextStep,
    goToPreviousStep,
    infoMessage,
    init,
    isCurrentStepOptional,
    isRefreshingResults,
    isLoadingResults,
    isLoadingSchema,
    isOptionSelected,
    meta,
    onOptionClick,
    progress,
    resetAll,
    showResults,
    showSimilar,
    skipStep,
    sortMode,
    sortedResults,
    stepIndex,
    steps,
    applyFeedback,
} = useAiConfigurator();

const currentStepLabel = computed(() => {
    if (!currentStep.value) {
        return '';
    }

    const stepNumber = Number(stepIndex.value || 0) + 1;
    return `Krok ${stepNumber} z ${steps.value.length}`;
});

const isLastStep = computed(() => stepIndex.value === steps.value.length - 1);

const touchState = {
    x: 0,
    y: 0,
};

function onWizardTouchStart(event) {
    const touch = event?.changedTouches?.[0];
    if (!touch) {
        return;
    }

    touchState.x = Number(touch.clientX || 0);
    touchState.y = Number(touch.clientY || 0);
}

async function onWizardTouchEnd(event) {
    const touch = event?.changedTouches?.[0];
    if (!touch) {
        return;
    }

    const endX = Number(touch.clientX || 0);
    const endY = Number(touch.clientY || 0);
    const deltaX = endX - touchState.x;
    const deltaY = endY - touchState.y;

    if (Math.abs(deltaX) < 50 || Math.abs(deltaX) < Math.abs(deltaY)) {
        return;
    }

    if (deltaX < 0) {
        await goToNextStep();
        return;
    }

    goToPreviousStep();
}

onMounted(async () => {
    await init();
});

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      (_unref(isLoadingSchema))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
        : (!_unref(showResults) && _unref(currentStep))
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "AiConfigurator__wizard",
              onTouchstartPassive: onWizardTouchStart,
              onTouchendPassive: onWizardTouchEnd
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", {
                    class: "AiConfigurator__progressFill",
                    style: _normalizeStyle({ width: `${_unref(progress)}%` })
                  }, null, 4)
                ]),
                _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(currentStepLabel)), 1)
              ]),
              _createVNode(_Transition, {
                name: "ai-step",
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock("div", {
                    key: _unref(currentStep).id,
                    class: "AiConfigurator__step"
                  }, [
                    _createElementVNode("h3", _hoisted_12, _toDisplayString(_unref(currentStep).question), 1),
                    _createElementVNode("div", {
                      class: _normalizeClass(["AiConfigurator__options", { 'is-multi': _unref(currentStep).type === 'multi' }])
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentStep).options, (option) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: option.id,
                          class: _normalizeClass(["Button--no-style AiConfigurator__option", { 'is-selected': _unref(isOptionSelected)(_unref(currentStep), option.id) }]),
                          type: "button",
                          onClick: $event => (_unref(onOptionClick)(_unref(currentStep), option))
                        }, [
                          _createElementVNode("span", null, _toDisplayString(option.label), 1),
                          (_unref(currentStep).type === 'multi')
                            ? (_openBlock(), _createElementBlock("small", _hoisted_14, _toDisplayString(_unref(isOptionSelected)(_unref(currentStep), option.id) ? 'Wybrane' : 'Wybierz'), 1))
                            : _createCommentVNode("", true)
                        ], 10, _hoisted_13))
                      }), 128))
                    ], 2)
                  ]))
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("button", {
                  type: "button",
                  class: "Button--no-style AiConfigurator__btn AiConfigurator__btn--ghost",
                  onClick: _cache[0] || (_cache[0] = (...args) => (_unref(goToPreviousStep) && _unref(goToPreviousStep)(...args))),
                  disabled: !_unref(canGoBack)
                }, " Wstecz ", 8, _hoisted_16),
                (_unref(isCurrentStepOptional)())
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "Button--no-style AiConfigurator__btn AiConfigurator__btn--soft",
                      onClick: _cache[1] || (_cache[1] = (...args) => (_unref(skipStep) && _unref(skipStep)(...args)))
                    }, " Pomijam ten krok "))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "Button--no-style AiConfigurator__btn AiConfigurator__btn--primary",
                  disabled: !_unref(canGoForward) || _unref(isLoadingResults),
                  onClick: _cache[2] || (_cache[2] = (...args) => (_unref(goToNextStep) && _unref(goToNextStep)(...args)))
                }, _toDisplayString(_unref(isLastStep) ? 'Pokaż propozycje' : 'Dalej'), 9, _hoisted_17)
              ])
            ], 32))
          : _createCommentVNode("", true),
      (_unref(showResults))
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", null, [
                _hoisted_20,
                _createElementVNode("p", _hoisted_21, " Kandydatów po filtrze budżetu: " + _toDisplayString(_unref(meta).after_budget_filter || 0) + " · powyżej progu: " + _toDisplayString(_unref(meta).above_threshold || 0), 1)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("label", null, [
                  _createTextVNode(" Sortuj: "),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_isRef(sortMode) ? (sortMode).value = $event : null)),
                    class: "AiConfigurator__select"
                  }, _hoisted_26, 512), [
                    [_vModelSelect, _unref(sortMode)]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("button", {
                type: "button",
                class: "Button--no-style AiConfigurator__btn AiConfigurator__btn--soft",
                onClick: _cache[4] || (_cache[4] = (...args) => (_unref(editAnswers) && _unref(editAnswers)(...args)))
              }, " Zmień odpowiedzi "),
              _createElementVNode("button", {
                type: "button",
                class: "Button--no-style AiConfigurator__btn AiConfigurator__btn--ghost",
                onClick: _cache[5] || (_cache[5] = (...args) => (_unref(resetAll) && _unref(resetAll)(...args)))
              }, " Start od nowa ")
            ]),
            (_unref(infoMessage))
              ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(_unref(infoMessage)), 1))
              : _createCommentVNode("", true),
            (_unref(errorMessage))
              ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(_unref(errorMessage)), 1))
              : _createCommentVNode("", true),
            _hoisted_30,
            (_unref(isLoadingResults) && !_unref(sortedResults).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_34))
              : (!_unref(sortedResults).length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_37))
                : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    (_unref(isRefreshingResults))
                      ? (_openBlock(), _createElementBlock("p", _hoisted_39, "Aktualizuję dopasowanie..."))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortedResults), (product) => {
                      return (_openBlock(), _createElementBlock("article", {
                        key: product.id,
                        class: "AiConfigurator__card"
                      }, [
                        _createElementVNode("a", {
                          href: product.url,
                          class: "AiConfigurator__imageWrap",
                          target: "_blank",
                          rel: "noopener noreferrer"
                        }, [
                          _createElementVNode("img", {
                            src: product.image,
                            alt: product.title,
                            loading: "lazy"
                          }, null, 8, _hoisted_41),
                          _createElementVNode("span", _hoisted_42, _toDisplayString(Number(product.match_score).toFixed(1)) + "% · " + _toDisplayString(product.match_hearts), 1)
                        ], 8, _hoisted_40),
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("a", {
                            href: product.url,
                            class: "AiConfigurator__name",
                            target: "_blank",
                            rel: "noopener noreferrer"
                          }, _toDisplayString(product.title), 9, _hoisted_44),
                          _createElementVNode("p", _hoisted_45, _toDisplayString(_unref(formatPrice)(product.price)), 1),
                          _createElementVNode("p", _hoisted_46, _toDisplayString(product.why_for_you), 1),
                          _createElementVNode("div", _hoisted_47, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((product.matched_tags || []).slice(0, 8), (tag) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: `${product.id}-${tag}`
                              }, " #" + _toDisplayString(tag), 1))
                            }), 128))
                          ]),
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("a", {
                              class: "AiConfigurator__link",
                              href: product.url,
                              target: "_blank",
                              rel: "noopener noreferrer"
                            }, "Zobacz szczegóły", 8, _hoisted_49),
                            _createElementVNode("button", {
                              type: "button",
                              class: "Button--no-style AiConfigurator__link AiConfigurator__link--button",
                              disabled: _unref(isRefreshingResults),
                              onClick: $event => (_unref(showSimilar)(product))
                            }, " Pokaż podobne ", 8, _hoisted_50)
                          ]),
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("button", {
                              type: "button",
                              class: _normalizeClass(["Button--no-style AiConfigurator__feedbackBtn", { 'is-active': _unref(getFeedbackType)(product.id) === 'like' }]),
                              title: "Trafione - pokaż więcej takich propozycji",
                              "aria-label": "Trafione - pokaż więcej takich propozycji",
                              disabled: _unref(isRefreshingResults),
                              onClick: $event => (_unref(applyFeedback)(product, 'like'))
                            }, _hoisted_55, 10, _hoisted_52),
                            _createElementVNode("button", {
                              type: "button",
                              class: _normalizeClass(["Button--no-style AiConfigurator__feedbackBtn", { 'is-active': _unref(getFeedbackType)(product.id) === 'dislike' }]),
                              title: "Nie dla mnie - ogranicz podobne propozycje",
                              "aria-label": "Nie dla mnie - ogranicz podobne propozycje",
                              disabled: _unref(isRefreshingResults),
                              onClick: $event => (_unref(applyFeedback)(product, 'dislike'))
                            }, _hoisted_59, 10, _hoisted_56)
                          ])
                        ])
                      ]))
                    }), 128))
                  ]))
          ]))
        : _createCommentVNode("", true),
      (_unref(errorMessage) && !_unref(showResults))
        ? (_openBlock(), _createElementBlock("p", _hoisted_60, _toDisplayString(_unref(errorMessage)), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

}